export default __webpack_public_path__ + "static/media/thankYouChil.525178a1.svg";